import React, { ReactNode, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Switch, Text } from '@chakra-ui/react'

import { removeDecimals } from 'utils/removeDecimals'

import { SwitchBoxWrapper } from './styles'

interface Props {
  title: React.ReactNode
  price: string | number | null
  topExtraText?: string
  bottomExtraText?: ReactNode
  onChange: (checked: boolean) => void
  defaultChecked?: boolean
  disabled?: boolean
  hideSwitch?: boolean
}

const SwitchBox = ({
  title,
  price,
  topExtraText,
  bottomExtraText,
  onChange,
  defaultChecked,
  disabled,
  hideSwitch,
  ...boxProps
}: Props): JSX.Element | null => {
  const { t } = useTranslation(['common'])

  const changeHandler = useCallback(
    (e: { checked: boolean }) => {
      return onChange(e.checked)
    },
    [onChange],
  )

  if (!title || !price) {
    return null
  }

  return (
    <SwitchBoxWrapper {...boxProps}>
      <Box>
        {topExtraText && <Text fontSize="xs">{topExtraText}</Text>}
        <Text fontSize="md">{title}</Text>
        <Text fontSize="sm" color="green.a200" fontWeight={700}>
          {price !== '' ? `${removeDecimals(price)} ${t('NOK')}` : `...`}
        </Text>

        {bottomExtraText && <Box marginTop={2}>{bottomExtraText}</Box>}
      </Box>

      <Box>
        {!hideSwitch && (
          <Switch.Root
            size="lg"
            colorPalette="leidTheme"
            variant="solid"
            onCheckedChange={changeHandler}
            checked={defaultChecked}
            defaultChecked={defaultChecked}
            disabled={disabled}
          >
            <Switch.HiddenInput />
            <Switch.Control />
          </Switch.Root>
        )}
      </Box>
    </SwitchBoxWrapper>
  )
}

export default SwitchBox
